/**
 * Extracts manufacturer from custom.manufacturer metafield
 * If metafield contains " and ", extracts only the manufacturer part
 */
(function() {
  function extractManufacturer() {
    // Find the manufacturer text block (first text block before product title)
    const headerGroup = document.querySelector('.product-information .group-block');
    if (!headerGroup) return;

    const textBlocks = headerGroup.querySelectorAll('.text-block');
    if (textBlocks.length === 0) return;

    const manufacturerBlock = textBlocks[0];
    
    // Skip if already processed
    if (manufacturerBlock.classList.contains('manufacturer-processed')) {
      return;
    }
    
    const paragraph = manufacturerBlock.querySelector('p');
    if (!paragraph) return;
    
    const metafieldValue = paragraph.textContent.trim();
    if (!metafieldValue) return;
    
    // If metafield contains " and ", extract only the manufacturer (first part)
    let manufacturer = metafieldValue;
    if (metafieldValue.includes(' and ')) {
      const parts = metafieldValue.split(' and ');
      manufacturer = parts[0] ? parts[0].trim() : metafieldValue;
    }
    
    // Update the text
    if (manufacturer !== metafieldValue) {
      paragraph.textContent = manufacturer;
    }
    
    // Mark as processed
    manufacturerBlock.classList.add('manufacturer-processed');
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', extractManufacturer);
  } else {
    extractManufacturer();
  }

  // Run after dynamic content updates
  document.addEventListener('shopify:section:load', extractManufacturer);
})();

